module.exports = __webpack_public_path__ + "6c70a0f958f58309b29d920ac447af95.svg";